/**
 * semanticDeduplicationEngine — Detects repeated semantic themes across all layer block texts.
 *
 * When 2+ layer blocks contain the same essential concept, collapses to ONE canonical line.
 * Operates on raw block text strings — no layer-specific assumptions.
 *
 * Returns { dedupedThemes, dedupCount, canonicals }
 */

const SEMANTIC_CLUSTERS = [
  {
    theme:     "ritmo_lento",
    patterns:  [/reduce.*ritmo/i, /pausa.*avance/i, /sin precipitar/i, /avanza.*cuidado/i, /mueve.*despacio/i, /no.*presiones/i, /no.*apresures/i, /despacio/i],
    canonical: "Ritmo pausado.",
  },
  {
    theme:     "sin_presion",
    patterns:  [/no más carga/i, /no agravar/i, /reduce.*presión/i, /no exij/i, /aligera.*carga/i, /sin más peso/i],
    canonical: "Sin presión.",
  },
  {
    theme:     "ternura",
    patterns:  [/con ternura/i, /con suavidad/i, /gentileza/i, /con cuidado/i, /con delicadeza/i, /suave[^z]/i],
    canonical: "Con ternura.",
  },
  {
    theme:     "presencia",
    patterns:  [/acompaña.*paciencia/i, /prioriza.*presencia/i, /sostén.*presencia/i, /solo.*presencia/i, /estar.*presente/i, /presencia.*sin.*agenda/i],
    canonical: "Solo presencia.",
  },
  {
    theme:     "descanso",
    patterns:  [/invite.*descanso/i, /permiso.*descansar/i, /descansar.*culpa/i, /alivio.*carga/i, /descanso.*pastoral/i],
    canonical: "Invita al descanso.",
  },
  {
    theme:     "escucha",
    patterns:  [/escucha.*sin.*juzgar/i, /espacio.*hablar/i, /deja.*hablar/i, /escucha activa/i, /solo.*escucha/i, /escuchar.*primero/i],
    canonical: "Solo escuchar.",
  },
  {
    theme:     "no_analizar",
    patterns:  [/no.*analiz/i, /evita.*análisis/i, /menos.*análisis/i, /no.*diagnos/i, /sin.*evaluar/i],
    canonical: "Sin análisis.",
  },
];

export function runSemanticDeduplication(blockTexts) {
  // Scan each block individually to count cross-block matches
  const dedupedThemes = [];

  for (const { theme, patterns, canonical } of SEMANTIC_CLUSTERS) {
    // Count how many distinct blocks match at least one pattern in this cluster
    const blocksMatching = blockTexts.filter(
      (b) => b && patterns.some((p) => p.test(b))
    ).length;

    if (blocksMatching >= 2) {
      dedupedThemes.push({ theme, canonical, matchCount: blocksMatching });
    }
  }

  return {
    dedupedThemes,
    dedupCount: dedupedThemes.length,
    canonicals:  dedupedThemes.map((d) => d.canonical),
  };
}
